<template>
    <section class="barocare-b2c-service-use" id="barocare-b2c-service-use">
        <div class="container">
            <div class="title-area" v-intersect>
                <span class="text-primary">쉽고 편리한 바로돌봄</span>
                <h2 class="text-xl">바로돌봄 이용 방법</h2>
            </div>
            <ol class="item-group-column">
                <li class="item" v-intersect>
                    <div class="text">
                        <span class="step">STEP 01</span>
                        <strong class="title">상담원을 통한 간편 진료 예약</strong>
                        <p>카카오 채팅방으로 바로돌봄 상담원을 통해<br>간편하게 진료를 예약하세요</p>
                        <div class="box">
                            <strong><span>*</span> 약배송 약 2-3일 소요</strong>  
                            <p>최초 사용에 한하여 환자 등록이 필요하며<br>상담시 해당 링크를 전달드립니다.</p>
                        </div>
                    </div>
                    <div class="img">
                        <img src="../../assets/pc_barocare_b2c/service-use01.png" alt="카카오 채팅방 화면"/>
                        <img src="../../assets/pc_barocare_b2c/service-use02.png" alt="환자 등록 화면"/>
                    </div>
                </li>
                <li class="item" v-intersect>
                    <div class="text">
                        <span class="step">STEP 02</span>
                        <strong class="title">전화 진료 진행</strong>
                        <p>전화를 통해<br>의사와 진료를 진행합니다</p>
                    </div>
                    <div class="img">
                        <img src="../../assets/pc_barocare_b2c/service-use03.png" alt=""/>
                    </div>
                </li>
                <li class="item" v-intersect>
                    <div class="text">
                        <span class="step">STEP 03</span>
                        <strong class="title">배송 및 결제</strong>
                        <p>카카오톡으로 결제 금액과<br>배송정보를 확인하고<br>약을 배송받으세요<br><br><span class="sub-text"><span class="text-primary">*</span> 약배송 약 2-3일 소요</span></p>
                    </div>
                    <div class="img">
                        <img src="../../assets/pc_barocare_b2c/service-use04.png" alt="카카오 채팅방 결제 및 배송 화면"/>
                    </div>
                </li>
            </ol>
        </div>
    </section>
</template>

<script>
export default {
    name: 'BarocareB2cServiceUse',
    directives: {
        intersect: {
            // 요소가 DOM에 삽입될 때 호출됩니다.
            inserted(el) {
                const options = {
                    root: null, // 뷰포트를 기본값으로 설정
                    rootMargin: '0px', // 뷰포트의 마진은 0
                    threshold: 0.1 // 10%가 보일 때 콜백이 실행
                };
                const callback = (entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            el.classList.add('visible');
                        } else {
                            el.classList.remove('visible');
                        }
                    });
                };
                const observer = new IntersectionObserver(callback, options);
                observer.observe(el); // 해당 요소를 관찰 시작
            }
        }
    },
}
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/pc_barocare_b2c/BarocareB2cServiceUse.vue